module.exports = __webpack_public_path__ + "static/img/H6W.985ff866.png";